// frontend/src/components/ActionPlans/Categories.jsx

import React from 'react';
import { ap_categoriesAPI } from '../../api/client';
import { useTranslation } from '../../context/TranslationContext';
import MasterDataManager from '../Common/MasterDataManager';

const APCategories = () => {
  const { t } = useTranslation();

  const columns = [
    {
      header: t('categories.name', 'Name'),
      field: 'category_name'
    },
    {
      header: t('active', 'Active'),
      field: 'is_active',
      render: (row) => row.is_active ? '✓' : '—'
    },
    {
      header: t('created_at', 'Created'),
      field: 'created_at',
      render: (row) => new Date(row.created_at).toLocaleDateString()
    }
  ];

  const formFields = [
    {
      name: 'category_name',
      label: 'categories.name',
      type: 'text',
      required: true,
      maxLength: 100
    },
    {
      name: 'is_active',
      label: 'active',
      type: 'checkbox',
      defaultValue: true,
      checkboxLabel: 'active'
    }
  ];

  return (
    <MasterDataManager
      title="categories.title"
      subtitle="categories.subtitle"
      createButtonLabel="categories.create"
      api={ap_categoriesAPI}
      columns={columns}
      formFields={formFields}
      idField="category_id"
      displayField="category_name"
    />
  );
};

export default APCategories;